import { create } from "zustand";

interface TutorialState {
    isOpen: boolean;
    open: () => void;
    close: () => void;
}

export const useTutorialStore = create<TutorialState>((set) => ({
    isOpen: false,
    open: () => set({ isOpen: true }),
    close: () => set({ isOpen: false }),
}));
